// i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
  zh: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "分类",
      ProductDetails: "产品详情",
      ProductInstructions: "产品说明",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "复制",
      Copied: "已复制",
      WhereToBuy: "购买途径",
      ContactUs: "联系我们",
      BasicInformation: "基础信息",
      ProductName: "产品名称",
      ProductNumber: "产品编号",
      TradeCode: "交易编号",
      DetailsParameters: "详细参数",
      OeInformation: "原厂信息",
    }

  },
  my: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "Klasifikasi",
      ProductDetails: "Butiran produk",
      ProductInstructions: "Penerangan produk",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "Salinan",
      Copied: "Telah disalin",
      WhereToBuy: "Cara pembelian",
      ContactUs: "Hubungi kami",
      BasicInformation: "Maklumat asas",
      ProductName: "Nama produk",
      ProductNumber: "Nombor produk",
      TradeCode: "Nombor transaksi",
      DetailsParameters: "Parameter terperinci",
      OeInformation: "Maklumat asal pabrik",
    }

  },
  th: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "การจัดหมวดหมู่",
      ProductDetails: "รายละเอียดสินค้า",
      ProductInstructions: "คำอธิบายผลิตภัณฑ์",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "ก๊อปปี้",
      Copied: "คัดลอกแล้ว",
      WhereToBuy: "ช่องทางการซื้อ",
      ContactUs: "ติดต่อเรา",
      BasicInformation: "ข้อมูลพื้นฐาน",
      ProductName: "ชื่อผลิตภัณฑ์",
      ProductNumber: "หมายเลขผลิตภัณฑ์",
      TradeCode: "หมายเลขธุรกรรม",
      DetailsParameters: "รายละเอียดพารามิเตอร์",
      OeInformation: "ข้อมูลต้นฉบับจากโรงงาน",
    }

  },
  id: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "Klasifikasi",
      ProductDetails: "Detail Produk",
      ProductInstructions: "Deskripsi Produk",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "Menyalin",
      Copied: "Sudah disalin",
      WhereToBuy: "Cara pembelian",
      ContactUs: "Hubungi kami",
      BasicInformation: "Informasi dasar",
      ProductName: "Nama Produk",
      ProductNumber: "Nomor produk",
      TradeCode: "Nomor transaksi",
      DetailsParameters: "Parameter detail",
      OeInformation: "Informasi pabrik asli",
    }

  },
  en: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "Category",
      ProductDetails: "Product details",
      ProductInstructions: "Product instructions",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "Copy",
      Copied: "Copied",
      WhereToBuy: "Where To Buy",
      ContactUs: "Contact Us",
      BasicInformation: "Basic Information",
      ProductName: "Product Name",
      ProductNumber: "Product Number",
      TradeCode: "Trade Code",
      DetailsParameters: "Details Parameters",
      OeInformation: "OE Information",
    }

  },
  vn: {
    message: {
      PN: "PN",
      ShortCode: "Short code",
      Category: "phân loại",
      ProductDetails: "Chi tiết sản phẩm",
      ProductInstructions: "Hướng dẫn sử dụng sản phẩm",
      AntiFakeResult: "Scan Tracker",
      CatalogueTitle: "Bosch AutoParts Catalogue",

      Copy: "sao chép",
      Copied: "Đã sao chép",
      WhereToBuy: "Cách thức mua hàng",
      ContactUs: "Liên hệ chúng tôi",
      BasicInformation: "Thông tin cơ bản",
      ProductName: "Tên sản phẩm",
      ProductNumber: "Mã sản phẩm",
      TradeCode: "Mã giao dịch",
      DetailsParameters: "Thông số chi tiết",
      OeInformation: "Thông tin chính hãng",
    }

  }

};

const i18n = new VueI18n({
  locale: 'en', // 默认语言
  fallbackLocale: 'en',
  messages,
});

export default i18n;